import {Component, Input, OnInit} from '@angular/core';
import {INavigationType} from "../../../navigation.interface";
import {NavigationService} from "../../../navigation.service";
import {MenuItemCategories} from "../../../navigation.enum";
import {NavigationInteractionsService} from "../../../navigation-interactions.service";

@Component({
    selector: 'db-ecommerce-navigation-item',
    templateUrl: './ecommerce-navigation-item.component.html',
    styleUrls: ['./ecommerce-navigation-item.component.scss'],
    standalone: false
})
export class EcommerceNavigationItemComponent implements OnInit {
  @Input() menuItem: INavigationType;
  isEditView = false;
  types = MenuItemCategories;
  editItem: INavigationType;

  constructor(private _navigationService: NavigationService,
              public navigationInteractionsService: NavigationInteractionsService) {
  }

  ngOnInit() {
  }

  setEdit(value) {
    this.editItem = value;
  }

  onSaveItem(item: INavigationType) {
    this.editItem = null;
    this.navigationInteractionsService.hasChanges.next(true);
    this.navigationInteractionsService.editNavigationItem(item, item.temp_id || item.id);
  }

  onDeleteItem(item: INavigationType) {
    this.editItem = null;
    this.navigationInteractionsService.hasChanges.next(true);
    this.navigationInteractionsService.deleteNavigationItem(item.temp_id || item.id);
  }

}
